import { createContext } from 'react';

import {
  ILoginCredentials,
  IGoogleLoginCredentials,
} from '../schemas/apis/interface';

interface AlertState {
  open: boolean;
  message: string;
  severity: 'success' | 'error';
}

interface AuthContextType {
  isAuthenticated: boolean;
  login: (credentials: ILoginCredentials) => Promise<void>;
  googleLogin: (credentials: IGoogleLoginCredentials) => Promise<void>;
  logout: () => void;
  isLoading: boolean;
  error: Error | null;
  alert: AlertState;
  setAlert: (alert: AlertState) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
